import React from "react";
import { Section, FadeUp, Eyebrow, CtaButton } from "./primitives";

export const FinalCta = () => (
  <Section className="bg-zinc-950 text-white">
    <div className="max-w-[720px] mx-auto text-center">
      <FadeUp>
        <Eyebrow dark>Last Call</Eyebrow>
        <h2 className="text-3xl md:text-5xl font-black tracking-tight leading-tight text-white">
          Ready To Finally Break Through?
        </h2>
      </FadeUp>
      <FadeUp delay={0.05}>
        <div className="mt-8 space-y-5 text-lg md:text-xl text-zinc-300 leading-relaxed">
          <p>This is the exact approach I've used with my own students for years.</p>
          <p className="font-bold text-white">I know it works.</p>
          <p>
            The only question now is whether you finally get there, or keep searching for the answer on your own.
          </p>
          <p>Spaces for this first cohort are extremely limited.</p>
          <p className="font-bold text-white">Once they're gone, they're gone.</p>
        </div>
      </FadeUp>
      <FadeUp delay={0.1}>
        <div className="mt-12">
          <CtaButton testid="cta-final-apply" dark microcopy="Apply now to be considered for the first cohort." />
        </div>
      </FadeUp>
    </div>
    <div className="mt-20 text-center">
      <p className="font-black tracking-tight text-white">Full Time Guitar</p>
      <p className="mt-2 text-sm text-zinc-500">&copy; {new Date().getFullYear()} Lead Guitar Freedom. All rights reserved.</p>
    </div>
  </Section>
);
